// actions.js
import * as actionTypes from './actionsTypes';

export const setValueInvestissement = (value) => ({
  type: actionTypes.SET_VALUE_INVESTISSEMENT,
  payload: value,
});

export const setStatutInvestissement = (statut) => ({
  type: actionTypes.SET_STATUT_INVESTISSEMENT,
  payload: statut,
});

export const setClasseImmo = (annee) => ({
  type: actionTypes.SET_ClASSE_IMMOBILISATION,
  payload: annee,
});

export const setCurrentPageInvestissement = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_INVESTISSEMENT,
  payload: page,
});

export const setOrderInvestissement = (order) => ({
  type: actionTypes.SET_ORDER_INVESTISSEMENT,
  payload: order,
});

export const setSortFieldInvestissement = (field) => ({
  type: actionTypes.SET_SORT_FIELD_INVESTISSEMENT,
  payload: field,
});
  
  
  

  
  